import React from "react";

export default function LoginFooter() {
  return (
    <>
      <footer className="container pt-8 px-3 text-center">
        {/*<div className="flex justify-center space-x-5 mb-4">*/}
        {/*  <a*/}
        {/*    href="https://jeevee.com/terms.html"*/}
        {/*    target="_blank"*/}
        {/*    rel="noreferrer"*/}
        {/*    className="link"*/}
        {/*  >*/}
        {/*    Terms of Use*/}
        {/*  </a>*/}
        {/*  <a*/}
        {/*    href="https://jeevee.com/privacy-policy.html"*/}
        {/*    target="_blank"*/}
        {/*    rel="noreferrer"*/}
        {/*    className="link"*/}
        {/*  >*/}
        {/*    Privacy Policy*/}
        {/*  </a>*/}

        {/*</div>*/}
        <div className="text-sm text-white font-light">
          Copyright &copy; {' '}{new Date().getFullYear()} Jeevee. All Rights Reserved.
        </div>
      </footer>
    </>
  );
}